import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material/';

export const StyledDatePickerErrorTypography = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    ...theme.typography.mobileParagraphSmall,
  },
  [theme.breakpoints.up('xl')]: {
    ...theme.typography.paragraphSmall,
  },
  color: theme.palette.error.main,
}));
